import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import axiosService from '../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

const VISIBILITY_LABELS = {
  budget: 'Budget table',
  timeline: 'Project timeline',
  report: 'Campaign report',
}

const VISIBILITY_TOASTS = {
  budget: {
    visible: 'Budget table visible for advertiser',
    hidden: 'Budget table hidden from advertiser',
  },
  timeline: {
    visible: 'Project timeline visible for advertiser',
    hidden: 'Project timeline hidden from advertiser',
  },
  report: {
    visible: 'Campaign report visible for advertiser',
    hidden: 'Campaign report hidden from advertiser',
  },
}

export default observer(function CampaignScenario({ campaignScenario, visibilityKind = 'budget' }) {
  const { id } = useParams()
  const { campaign } = useContext(CampaignContext)
  const readOnly = useReadOnly()

  const visible =
    visibilityKind === 'report'
      ? campaign.show_report
      : visibilityKind === 'timeline'
        ? campaignScenario.timeline_visible
        : campaign.budget_table_visible

  const toggleIsVisible = () => {
    if (visibilityKind === 'report') {
      axiosService.patch(`/api/project_manager/campaigns/${id}`, { campaign: { show_report: !campaign.show_report } })
        .then(updatedCampaign => {
          campaign.show_report = updatedCampaign.show_report
          const toasts = VISIBILITY_TOASTS.report
          toastSuccess(updatedCampaign.show_report ? toasts.visible : toasts.hidden)
        })
        .catch(({ data: { error } }) => toastError(error))
      return
    }

    if (visibilityKind === 'budget') {
      axiosService.patch(`/api/project_manager/campaigns/${id}`, { campaign: { budget_table_visible: !campaign.budget_table_visible } })
        .then(updatedCampaign => {
          campaign.budget_table_visible = !!updatedCampaign.budget_table_visible
          const toasts = VISIBILITY_TOASTS.budget
          toastSuccess(campaign.budget_table_visible ? toasts.visible : toasts.hidden)
        })
        .catch(({ data: { error } }) => toastError(error))
      return
    }

    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${campaignScenario?.id}`, {
      campaign_scenario: { timeline_visible: !campaignScenario.timeline_visible },
    })
      .then(updatedCampaignScenario => {
        campaignScenario.timeline_visible = !!updatedCampaignScenario.timeline_visible
        const toasts = VISIBILITY_TOASTS.timeline
        toastSuccess(campaignScenario.timeline_visible ? toasts.visible : toasts.hidden)
      })
      .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <button
      className={`bg-gray-100 dark:bg-rb-dark-mode-lighter font-semibold rounded-xl p-2 flex items-center dark:text-white ${readOnly ? 'cursor-default' : ''}`}
      type="button"
      onClick={toggleIsVisible}
      disabled={readOnly}
    >
      <p className="mr-2">{VISIBILITY_LABELS[visibilityKind]}</p>
      {visible ? <Eye className="dark:text-white" /> : <EyeSlash className="dark:text-white" />}
    </button>
  )
})
